import 'popper.js/dist/umd/popper';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/popover';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
